import { BookOpen, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Guides = () => {
  return (
    <section id="guides" className="py-16 md:py-24 bg-gradient-to-br from-gray-dark to-gray-medium text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center space-x-3 mb-6">
            <BookOpen className="text-yellow-accent" size={32} />
            <h2 className="text-3xl md:text-4xl font-bold">Casino Guides</h2>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-8">
            <h3 className="text-2xl font-bold mb-4 text-yellow-accent">
              How to Play Online Casinos in the UK
            </h3>
            <p className="text-lg text-gray-200 mb-6 leading-relaxed">
              Playing online casinos in the UK is straightforward, but knowing the 
              right approach can make all the difference. Start by choosing a licensed 
              operator – look for the UK Gambling Commission seal. Next, take advantage 
              of welcome bonuses to boost your starting balance. Always read the terms, 
              especially wagering requirements, to understand exactly what you're getting.
            </p>
            <p className="text-lg text-gray-200 mb-6 leading-relaxed">
              Set a budget before you play and stick to it. Use responsible gambling 
              tools like deposit limits and self-exclusion if needed. Remember, the 
              best players aren't just lucky – they're informed, disciplined, and choose 
              games with the best odds.
            </p>
            <Link
              to="/guides"
              data-discover="true"
              className="inline-flex items-center space-x-2 bg-yellow-accent text-gray-dark px-6 py-3 rounded-lg font-bold hover:bg-yellow-light transition-colors"
            >
              <span>Read Full Guides</span>
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guides;

